// Recommendation logic for /tools/photo-print-sizes. Pure data, no React.
// Option ids and the decision table follow the PBP-186 copy deck (section B2/B3),
// see docs/photo-print-sizes.md.

export const PLACE = {
  DESK: 'desk',
  WALLET: 'wallet',
  WALL_CLUSTER: 'wall-cluster',
  WALL_STATEMENT: 'wall-statement',
};

export const SHAPE = {
  SQUARE: 'square',
  RECTANGLE: 'rectangle',
  EITHER: 'either',
};

export const PLACE_OPTIONS = [
  { id: PLACE.DESK, label: 'Desk or shelf' },
  { id: PLACE.WALLET, label: 'Wallet, journal, or scrapbook' },
  { id: PLACE.WALL_CLUSTER, label: 'Wall: small cluster or grid' },
  { id: PLACE.WALL_STATEMENT, label: 'Wall: one big statement piece' },
];

export const SHAPE_OPTIONS = [
  { id: SHAPE.SQUARE, label: 'Square' },
  { id: SHAPE.RECTANGLE, label: 'Rectangle' },
  { id: SHAPE.EITHER, label: 'Either is fine' },
];

// One id per result path of the copy deck. Two 5x7 paths exist because the deck gives
// them different copy (frame-leaning vs. wall-cluster).
export const RESULT = {
  TINY_SQUARE: 'tiny-square',
  SQUARE_4X4: 'square-4x4',
  SQUARE_WALL: 'square-wall',
  CLASSIC_4X6: 'classic-4x6',
  CLASSIC_5X7: 'classic-5x7',
  CLASSIC_5X7_CLUSTER: 'classic-5x7-cluster',
  SQUARE_ENGINEER: 'square-engineer',
  ENGINEER: 'engineer',
};

// Wallet + Rectangle uses the smallest available rectangle, 4x6 Classic.
// Approved by Petr for v1 on 2026-09-10 because the copy deck omits this combination.
const DECISION_TABLE = {
  [PLACE.DESK]: {
    [SHAPE.SQUARE]: RESULT.SQUARE_4X4,
    [SHAPE.RECTANGLE]: RESULT.CLASSIC_4X6,
    [SHAPE.EITHER]: RESULT.SQUARE_4X4,
  },
  [PLACE.WALLET]: {
    [SHAPE.SQUARE]: RESULT.TINY_SQUARE,
    [SHAPE.RECTANGLE]: RESULT.CLASSIC_4X6,
    [SHAPE.EITHER]: RESULT.TINY_SQUARE,
  },
  [PLACE.WALL_CLUSTER]: {
    [SHAPE.SQUARE]: RESULT.SQUARE_WALL,
    [SHAPE.RECTANGLE]: RESULT.CLASSIC_5X7_CLUSTER,
    [SHAPE.EITHER]: RESULT.CLASSIC_5X7,
  },
  [PLACE.WALL_STATEMENT]: {
    [SHAPE.SQUARE]: RESULT.SQUARE_ENGINEER,
    [SHAPE.RECTANGLE]: RESULT.ENGINEER,
    [SHAPE.EITHER]: RESULT.ENGINEER,
  },
};

export const recommendPrintSize = (place, shape) => DECISION_TABLE[place]?.[shape] ?? null;

// Shorter print side in inches per result, the divisor of the PPI check (deck A3).
// The dual "4x4 or 5.5x5.5" result checks against the larger, stricter size.
export const PRINT_SHORT_SIDE_INCHES = {
  [RESULT.TINY_SQUARE]: 2.75,
  [RESULT.SQUARE_4X4]: 4,
  [RESULT.SQUARE_WALL]: 5.5,
  [RESULT.CLASSIC_4X6]: 4,
  [RESULT.CLASSIC_5X7]: 5,
  [RESULT.CLASSIC_5X7_CLUSTER]: 5,
  [RESULT.SQUARE_ENGINEER]: 36,
  [RESULT.ENGINEER]: 36,
};

export const isLargeFormat = (result) =>
  result === RESULT.ENGINEER || result === RESULT.SQUARE_ENGINEER;
